<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="12" md="8" lg="9">
            <h3>Gerenciar Tutoriais</h3>
          </b-col>
          <b-col sm="12" md="4" lg="3">
            <b-button @click="navigate('/tutorial/cadastrar')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Novo Tutorial</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="8">
            <b-form-group label="Título:">
              <b-form-input type="text" id="titulo" v-model="filtros.filter" placeholder="Título"></b-form-input>
            </b-form-group>
          </b-col>    
          <b-col md="2">
            <b-form-group tabindex="0" label="Situação:">
              <b-form-select tabindex="0" v-model="filtros.situacao" :options="status">
                <option :value="null" selected>Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
              <b-button block @click="limpar">
                <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
              </b-button>
            </b-col>
            <b-col sm="12" md="4" lg="3">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12" md="12">
          <b-container fluid>
            <span>
              <table aria-rowcount="4" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">Titulo</th>
                    <th scope="col">Status</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="tutoriais.data !== undefined">
                  <tr class="action" v-for="tutorial in tutoriais.data" :key="tutorial.id">
                    <td>{{ tutorial.titulo }}</td>
                    <td v-if="tutorial.situacao == '1 '">
                      <span class="badge badge-success">Ativo</span>
                    </td>
                    <td v-else>
                      <span class="badge badge-dark">Inativo</span>
                    </td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Visualizar Tutorial"
                        @click="visualizarTutorial(tutorial.id)">
                        <i class="fa fa-search"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Editar Tutorial"
                        @click="editarTutorial(tutorial.id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" :title="tutorial.situacao == 1 ? 'Inativar' : 'Ativar'"
                        @click="alternarAtivo(tutorial.id, tutorial.situacao)">
                        <i v-if="tutorial.situacao == 1" class="fa fa-toggle-off"></i>
                        <i v-else class="fa fa-toggle-on"></i>
                      </a>
                      <a class="btn btn-sm btn-primary action" title="Excluir Tutorial"
                        @click="excluirTutorial(tutorial.id)">
                        <i class="fa fa-times"></i>
                      </a>
                      <a class="btn btn-sm btn-secondary action" title="Tutorial" @click="verTutorial(tutorial.id)">
                        <i class="fa fa-eye"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="8">Nenhum registro de Tutorial...</td>
                  </tr>
                </tbody>
              </table>
              <pagination v-show="tutoriais.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource">
              </pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
  },
  data() {
    return {
      modalPreExcluir: false,
      totalPorPagina: 5,
      resource: 'tutorial',
      filtros: {
        filter: '',
        sistema_id: null,
        situacao: null
      },
      status: [
        { value: '1', text: 'Ativo' },
        { value: '0', text: 'Inativo' }
      ]
    }
  },
  computed: {
    tutorial() {
      return this.$store.state.tutorial.tutorial
    },
    tutoriais() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  watch: {
    //
  },
  methods: {
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_conferencia) {
        return true
      }
      return false
    },
    pesquisar() {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    navigate(route) {
      this.$router.push(route)
    },
    editarTutorial(id) {
      this.$router.push('/tutorial/' + id + '/editar')
    },
    verTutorial(id) {
      this.$router.push('/tutorial/' + id)
    },
    visualizarTutorial(id) {
      this.$router.push('/tutorial/' + id + '/visualizar')
    },
    excluirTutorial(id) {
      this.$bvModal.msgBoxConfirm('Confirma a exclusão do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/tutorial/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 12000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        } else {
          this.modalPreExcluir = true
        }
      })
    },
    alternarAtivo(id, situacao) {
      console.log(situacao)
      let mensagem = situacao == 1 ? 'Confirma a inativação do registro selecionado?' : 'Confirma ativação do registro selecionado?'
      console.log(mensagem)
      this.$bvModal.msgBoxConfirm(mensagem, {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/tutorial/alternar-situacao/' + id).then(response => {
            if (response.body.success) {
              this.alerta(true, response.body.msg)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            } else {
              this.alerta(false, response.body.msg)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(e => {
            console.log(e)
            this.alerta(false, e.body.msg)
            this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
          })
        }
      })
    },
    limpar() {
      for (const key in this.filtros) {
        this.filtros[key] = null
      }

      this.pesquisar()
    },
    alerta(success, msg) {
      if (success) {
        miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
        miniToastr.success(msg, 'Alerta!', 5000)
      } else {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error(msg, 'Sucesso!', 5000)
      }
    },
  }
}
</script>

<style>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/tutoriais/Tutoriais.vue